/**
 * Single source of truth for backend URL.
 * - Local: create `.env.development.local` with REACT_APP_API_URL=http://127.0.0.1:8000
 * - Production: omit env (defaults to production API) or set REACT_APP_API_URL in hosting CI.
 */
const raw = (process.env.REACT_APP_API_URL || 'https://api-ksecoks.alrglobal.eu').replace(/\/+$/, '');

export const API_ORIGIN = raw;
/** Trailing slash — use as axios baseURL */
export const API_URL = `${raw}/`;
/** Prefix for routes under /api/ */
export const API_BASE_URL = `${raw}/api`;
